<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="skeleton__wrapper">
    <div class="container">
      <div class="row mt-12">
        <div class="col-12">
          <CiSkeletonItem class="h-[130px] w-full lg:h-24" />
        </div>
      </div>

      <div class="row mt-12">
        <div class="col-12">
          <CiSkeletonItem class="mb-1 h-6 w-1/2 lg:w-1/5" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <CiSkeletonItem class="h-36 w-full lg:h-12" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6 mt-12">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="skeleton__input--title mb-4 h-14" />

          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="mb-4 h-32" />

          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="mb-4 h-32" />

          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="mb-4 h-[60px]" />
        </div>
        <div class="col-12 col-lg-6 mt-6 lg:mt-12">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="h-[508px]" />
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="h-[57px] w-full" />
        </div>

        <div class="col-12 col-lg-6 mt-12">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="h-[57px] w-full" />
        </div>

        <div class="col-12 col-lg-6 mt-6 lg:mt-12">
          <CiSkeletonItem class="mb-1 h-[20px] w-1/2 lg:w-1/5" />
          <CiSkeletonItem class="h-[57px] w-full" />
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>
